import { Link } from 'react-router-dom'
import { useMinCopy } from '@/i18n/useUiLocale'
import { cn } from '@/components/ui/cn'

/** Quiet, non-blocking link to the feedback form — for beta trust, not a banner. */
export function QuietFeedbackCta({
  className,
  testId = 'quiet-feedback-cta',
}: {
  className?: string
  testId?: string
}) {
  const { dashboard } = useMinCopy()

  return (
    <p className={cn('px-1 text-center text-xs text-muted-foreground', className)}>
      <Link
        to="/settings?tab=feedback"
        className="underline-offset-2 hover:text-foreground hover:underline"
        data-testid={testId}
      >
        {dashboard.feedbackCta}
      </Link>
    </p>
  )
}
